import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API, graphqlOperation, Storage, Auth } from "aws-amplify";
import { updateCandidateProfile } from "../graphql/mutations";
import awsExports from "../aws-exports";
import { RiseLoader } from "react-spinners";
import { listAdminAddCandidateContexts } from "../graphql/queries";
import upload from "../assets/iwwa_upload.svg";
import arrow from "../assets/iwwa_upload arrow.svg";
import axios from "axios";
import { createScreeningInterviewSlot } from "../utils/screeningUtils";
import { sendScreeningScheduleEmail } from "../utils/emailService";
import { FiX, FiMail, FiClock, FiSend } from "react-icons/fi";
import Header from "../components/header/Header";
import "./CandidateProfileReg.css";

// Configure AWS
API.configure(awsExports);
Auth.configure(awsExports);
Storage.configure(awsExports);

const CandidateProfileReg = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [candidateEmail, setCandidateEmail] = useState("");
  const [file, setFile] = useState(null);
  const [arrowAnimated, setArrowAnimated] = useState(false);
  const [isHovering, setIsHovering] = useState(false);
  const [isParsingResume, setIsParsingResume] = useState(false);
  const [parseError, setParseError] = useState(null);
  const [resumeFile, setResumeFile] = useState({});
  const [photoFile, setPhotoFile] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showScreeningPrompt, setShowScreeningPrompt] = useState(false);
  const [savedProfile, setSavedProfile] = useState(null);
  const [isStartingScreening, setIsStartingScreening] = useState(false);
  const [candidateProfileView, setCandidateProfileView] = useState(null);
  
  // Email interview link states
  const [isSendingEmail, setIsSendingEmail] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [createdSlotId, setCreatedSlotId] = useState(null);

  const [formData, setFormData] = useState({
    id: localStorage.getItem("candidateProfileId") || "",
    fullName: "",
    gender: "",
    mobileNumber: "",
    description: "",
    matchedPercentage: 0,
    workStatus: "",
    currentCity: "",
    educationDetails: "",
    keySkills: "",
    workPreference: "",
    preferredSalary: "",
    photo: null,
    resume: null,
    photoURL: "",
    resumeURL: "",
    roleApplyFor: "",
    address: "",
    workMode: [],
    workCategory: [],
    githubURL: "",
    linkedinURL: "",
  });

  const triggerFileUpload = () => {
    setArrowAnimated(true);
    setTimeout(() => setArrowAnimated(false), 500);
  };

  const handleResumeUpload = async (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;

    // Validate file type - only PDF allowed
    if (selectedFile.type !== 'application/pdf' && !selectedFile.name.toLowerCase().endsWith('.pdf')) {
      setParseError("Only PDF files are allowed. Please upload your resume in PDF format.");
      event.target.value = ''; // Reset file input
      return;
    }

    setResumeFile(selectedFile);
    setIsParsingResume(true);
    setParseError(null);

    try {
      const uploadFormData = new FormData();
      uploadFormData.append("resume", selectedFile);

      const response = await axios.post("https://phone.getscreened.in/parser/upload_resume", uploadFormData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      console.log("Resume upload response:", response);

      const parsedData = response.data;

      // Mapping API fields to your form state
      const updatedFields = {
        fullName: parsedData.name || "",
        currentCity: parsedData.currentCity || "",
        keySkills: parsedData.keySkills || "",
        mobileNumber: parsedData.phonenumber || "",
        email: parsedData.email || "",
        githubURL: parsedData.github || "",
        linkedinURL: parsedData.linkedin || "",
        description: parsedData.description || "",
        address: parsedData.address || "",
        roleApplyFor: parsedData.roleappliedfor !== "Not specified" ? parsedData.roleappliedfor || "" : "",
        workStatus: parsedData.workstatus !== "Not specified" ? parsedData.workstatus || "" : "",
      };

      // Update form state with parsed data
      setFormData((prev) => ({ ...prev, ...updatedFields }));

      console.log("Resume parsed successfully:", parsedData);
    } catch (error) {
      console.error("Resume parsing failed:", error);
      setParseError("Failed to parse resume. Please fill in the details manually.");
    } finally {
      setIsParsingResume(false);
    }

    setFile(selectedFile.name);
  };

  useEffect(() => {
    const candidateProfileEmailID = localStorage.getItem("candidateProfileEmailID");
    setCandidateEmail(candidateProfileEmailID);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await API.graphql(
          graphqlOperation(listAdminAddCandidateContexts)
        );
        const items = response.data.listAdminAddCandidateContexts.items;

        // Check if candidateEmail exists in any of the profiles
        const foundProfile = items.some(
          (profile) => profile.candidateEmail === candidateEmail
        );

        // Set candidateProfile based on whether the candidateEmail exists in the profiles
        setCandidateProfileView(foundProfile);
      } catch (error) {
        console.error("Error fetching candidate data:", error);
      }
    };

    // Fetch data only if candidateEmail exists
    if (candidateEmail) {
      fetchData();
    }
  }, [candidateEmail]);




  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    setPhotoFile(file);
  };

  const handleCheckboxChange = (e, fieldName) => {
    const { value, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [fieldName]: checked
        ? [...prev[fieldName], value] // Add value if checked
        : prev[fieldName].filter((item) => item !== value), // Remove if unchecked
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle starting screening now
  const handleStartScreeningNow = async () => {
    setIsStartingScreening(true);
    try {
      const candidateProfileId = localStorage.getItem("candidateProfileId");
      const candidateEmail = localStorage.getItem("candidateProfileEmailID");

      const screeningSlot = await createScreeningInterviewSlot({
        candidateProfileID: candidateProfileId,
        candidateEmail: candidateEmail,
        candidateProfile: savedProfile,
        numberOfQuestions: 5
      });

      localStorage.setItem("isScreeningRound", "true");
      localStorage.setItem("screeningSlotId", screeningSlot.id);

      navigate(`/public-interview/${screeningSlot.id}`);
    } catch (error) {
      console.error('Failed to create screening:', error);
      // Navigate to dashboard on error
      setShowScreeningPrompt(false);
      navigate('/CandidateSchedule');
    } finally {
      setIsStartingScreening(false);
    }
  };

  // Handle skipping screening for later - navigate to dashboard
  const handleScreeningLater = () => {
    setShowScreeningPrompt(false);
    setEmailSent(false);
    navigate('/CandidateSchedule');
  };

  // Handle sending interview link email (creates slot and sends email)
  const handleSendInterviewLinkEmail = async () => {
    setIsSendingEmail(true);
    try {
      const candidateProfileId = localStorage.getItem("candidateProfileId");
      const email = localStorage.getItem("candidateProfileEmailID");
      const candidateName = savedProfile?.fullName || formData.fullName || 'Candidate';

      // First, create a screening interview slot
      const screeningSlot = await createScreeningInterviewSlot({
        candidateProfileID: candidateProfileId,
        candidateEmail: email,
        candidateProfile: savedProfile,
        numberOfQuestions: 5
      });

      // Generate the interview link
      const interviewLink = `${window.location.origin}/public-interview/${screeningSlot.id}`;
      
      // Store the slot ID for reference
      setCreatedSlotId(screeningSlot.id);

      // Send email with the interview link
      await sendScreeningScheduleEmail({
        candidateEmail: email,
        candidateName: candidateName,
        interviewLink: interviewLink,
        slotId: screeningSlot.id,
      });

      setEmailSent(true);
      console.log('Interview link email sent successfully to:', email);
      console.log('Interview slot created:', screeningSlot.id);
    } catch (error) {
      console.error('Failed to send interview link email:', error);
      alert('Failed to send email. Please try again or start the interview from your dashboard.');
    } finally {
      setIsSendingEmail(false);
    }
  };


  const handleSubmit = async (event) => {

    event.preventDefault(); // Prevent form submission

    setIsSubmitting(true)

    // Validate resume is uploaded and is a PDF
    if (!resumeFile || !resumeFile.name) {
      alert("Please upload your resume in PDF format. Resume is mandatory.");
      setIsSubmitting(false);
      return;
    }

    if (resumeFile.type !== 'application/pdf' && !resumeFile.name.toLowerCase().endsWith('.pdf')) {
      alert("Only PDF files are allowed. Please upload your resume in PDF format.");
      setIsSubmitting(false);
      return;
    }

    if (
      !formData.fullName.trim() ||
      !formData.roleApplyFor.trim() ||
      !formData.workStatus.trim() ||
      !formData.mobileNumber.trim()
    ) {
      alert("Please fill all required fields (Full Name, Role, Work Status, Mobile Number).");
      setIsSubmitting(false);
      return; // Stop form submission
    }



    const yourS3BucketName = "getscreenedstoragebucketf24ed-devget"; // Adjust with your S3 Bucket name


    if (photoFile.name) {
      try {
        const { key: photoKey } = await Storage.put(
          `${Date.now()}_${photoFile.name}`,
          photoFile,
          { contentType: "image/*" } // or candidateProfile.photo.type for more specific types
        );
        formData.photoURL = `https://${yourS3BucketName}.s3.amazonaws.com/public/${photoKey}`;
      } catch (error) {
        console.error("Error uploading photo:", error);
        setIsSubmitting(false);
        return;
      }
    }


    if (resumeFile) {
      try {
        const { key: resumeKey } = await Storage.put(
          `${Date.now()}_${resumeFile.name}`,
          resumeFile,
          { contentType: "application/pdf" } // or candidateProfile.resume.type for more specific types
        );
        formData.resumeURL = `https://${yourS3BucketName}.s3.amazonaws.com/public/${resumeKey}`;
      } catch (error) {
        console.error("Error uploading resume:", error);
        setIsSubmitting(false);
        return;
      }
    }


    const mutationInput = {
      id: localStorage.getItem("candidateProfileId") || "", // Retrieve ID from local storage
      fullName: formData.fullName,
      gender: formData.gender,
      mobileNumber: formData.mobileNumber,
      description: formData.description,
      matchedPercentage: parseFloat(formData.matchedPercentage),
      workStatus: formData.workStatus,
      currentCity: formData.currentCity,
      educationDetails: formData.educationDetails,
      keySkills: formData.keySkills,
      workPreference: formData.workPreference,
      preferredSalary: parseFloat(formData.preferredSalary),
      photoURL: formData.photoURL,
      resumeURL: formData.resumeURL,
      roleApplyFor: formData.roleApplyFor, // New field
      address: formData.address, // New field
      workMode: formData.workMode,
      workCategory: formData.workCategory,
      githubURL: formData.githubURL,
      linkedinURL: formData.linkedinURL,
    };


    const response = await API.graphql(
      graphqlOperation(updateCandidateProfile, { input: mutationInput })
    );

    const updatedProfile = response.data.updateCandidateProfile;

    if (candidateProfileView) {
      // Existing profile - navigate to dashboard
      setIsSubmitting(false);
      navigate("/CandidateSchedule"); // Navigate to CandidateSchedule
    } else {
      // New profile - ask if they want to do screening now or later
      setIsSubmitting(false);
      setSavedProfile(updatedProfile || mutationInput);
      setShowScreeningPrompt(true);
    }
  }


  return (
    <div className="candidate-reg-page">
      <Header />
      
      {/* Screening Prompt Modal */}
      {showScreeningPrompt && (
        <div className="screening-modal-overlay">
          <div className="screening-modal screening-modal-wide">
            <div className="screening-modal-header">
              <h2>{emailSent ? '📧 Email Sent!' : 'Profile Created!'}</h2>
              <button onClick={handleScreeningLater} className="modal-close-btn">
                <FiX size={18} />
              </button>
            </div>
            <div className="screening-modal-content">
              {emailSent ? (
                <>
                  <div className="email-success-container">
                    <div className="email-success-icon">✓</div>
                    <p className="email-success-text">
                      We've sent your interview link to <strong>{localStorage.getItem("candidateProfileEmailID")}</strong>
                    </p>
                    <p className="email-success-subtext">
                      Check your inbox and click the link to start your interview anytime you're ready - it's available 24/7!
                    </p>
                  </div>
                  <div className="screening-modal-buttons">
                    <button
                      onClick={() => {
                        if (createdSlotId) {
                          localStorage.setItem("isScreeningRound", "true");
                          localStorage.setItem("screeningSlotId", createdSlotId);
                          navigate(`/public-interview/${createdSlotId}`);
                        }
                      }}
                      className="btn-secondary"
                      disabled={!createdSlotId}
                    >
                      <FiClock size={16} style={{ marginRight: '8px' }} />
                      Start Interview Now Instead
                    </button>
                    <button
                      onClick={handleScreeningLater}
                      className="btn-primary"
                    >
                      Go to Dashboard
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <p>
                    Would you like to complete a quick AI screening interview now? It takes about 5 minutes.
                  </p>
                  <div className="screening-modal-buttons">
                    <button
                      onClick={handleStartScreeningNow}
                      disabled={isStartingScreening}
                      className="btn-primary btn-highlight"
                    >
                      <FiClock size={16} style={{ marginRight: '8px' }} />
                      {isStartingScreening ? 'Starting...' : 'Start Screening Now'}
                    </button>
                    <button
                      onClick={handleSendInterviewLinkEmail}
                      disabled={isSendingEmail}
                      className="btn-secondary"
                    >
                      <FiSend size={16} style={{ marginRight: '8px' }} />
                      {isSendingEmail ? 'Creating & Sending...' : 'Email Me the Interview Link'}
                    </button>
                    <button
                      onClick={handleScreeningLater}
                      className="btn-tertiary"
                    >
                      Skip for Now
                    </button>
                  </div>
                  <p className="screening-modal-note">
                    You can start your interview anytime - it's available 24/7!
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      <div className="candidate-reg-container">
        <div className="candidate-reg-card">
          <h1 className="candidate-reg-title">Complete Your Profile</h1>
          <p className="candidate-reg-subtitle">Fill in your details to get started with GetScreened</p>

          {loading ? (
            <div className="loading-container">
              <RiseLoader
                color={"#9900ff"}
                loading={loading}
                size={40}
                aria-label="Loading Spinner"
              />
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="candidate-reg-content">
                {/* Left Side - Resume Upload */}
                <div 
                  className={`upload-card ${isHovering ? 'hovering' : ''}`}
                  onMouseEnter={() => setIsHovering(true)}
                  onMouseLeave={() => setIsHovering(false)}
                >
                  <label htmlFor="resume" className="upload-label" onClick={triggerFileUpload}>
                    <div className="upload-content">
                      <div className="upload-icons">
                        <img src={upload} alt="upload" className="upload-icon" />
                        <img 
                          src={arrow} 
                          alt="arrow" 
                          className={`arrow-icon ${arrowAnimated ? 'animated' : ''}`}
                        />
                      </div>
                      <span className="upload-title">Upload Resume</span>
                      <span className="upload-note">*Note: Upload document in PDF format</span>
                      {file && <p className="upload-filename">{file}</p>}
                      {isParsingResume && <div className="parsing-status">Parsing resume...</div>}
                    </div>
                  </label>
                  <input
                    type="file"
                    name="resume"
                    id="resume"
                    accept=".pdf"
                    onChange={handleResumeUpload}
                    className="hidden-input"
                  />
                  {parseError && <div className="parse-error">{parseError}</div>}
                </div>

                {/* Right Side - Form Fields */}
                <div className="form-section">
                  {/* Personal Information */}
                  <div className="form-group-title">Personal Information</div>
                  
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="fullName">Full Name *</label>
                      <input
                        type="text"
                        name="fullName"
                        placeholder="e.g. Chris Johnson"
                        value={formData.fullName}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="gender">Gender</label>
                      <select name="gender" value={formData.gender} onChange={handleChange}>
                        <option value="">Select Gender</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="mobileNumber">Mobile Number *</label>
                      <input
                        type="text"
                        name="mobileNumber"
                        placeholder="e.g. 9561471059"
                        value={formData.mobileNumber}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="currentCity">Current City</label>
                      <input
                        type="text"
                        name="currentCity"
                        placeholder="e.g. Pune"
                        value={formData.currentCity}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="form-group full-width">
                    <label htmlFor="address">Address</label>
                    <input
                      type="text"
                      name="address"
                      placeholder="e.g. Hinjewadi Phase 1, Wakad, Pune, Maharashtra"
                      value={formData.address}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group full-width">
                    <label htmlFor="description">About You</label>
                    <textarea
                      name="description"
                      placeholder="Brief description about yourself"
                      value={formData.description}
                      onChange={handleChange}
                      rows="3"
                    />
                  </div>

                  {/* Professional Information */}
                  <div className="form-group-title">Professional Information</div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="roleApplyFor">Role Apply For *</label>
                      <input
                        type="text"
                        name="roleApplyFor"
                        placeholder="e.g. Junior Data Scientist"
                        value={formData.roleApplyFor}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="workStatus">Work Status *</label>
                      <input
                        type="text"
                        name="workStatus"
                        placeholder="e.g. Fresher or 2 years experience"
                        value={formData.workStatus}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="form-group full-width">
                    <label htmlFor="keySkills">Key Skills</label>
                    <input
                      type="text"
                      name="keySkills"
                      placeholder="Separated by comma e.g. ReactJS, NextJS, Python"
                      value={formData.keySkills}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group full-width">
                    <label htmlFor="educationDetails">Education Details</label>
                    <textarea
                      name="educationDetails"
                      placeholder="e.g. B.Tech in Computer Science from XYZ University"
                      value={formData.educationDetails}
                      onChange={handleChange}
                      rows="2"
                    />
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="preferredSalary">Expected Salary (Annual)</label>
                      <input
                        type="text"
                        name="preferredSalary"
                        placeholder="e.g. 500000"
                        value={formData.preferredSalary}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="workPreference">Preferred Location</label>
                      <input
                        type="text"
                        name="workPreference"
                        placeholder="e.g. Pune, Mumbai"
                        value={formData.workPreference}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  {/* Work Preferences */}
                  <div className="form-group-title">Work Preferences</div>

                  <div className="form-row">
                    <div className="form-group">
                      <label>Work Mode</label>
                      <div className="checkbox-group">
                        {["Remote", "Hybrid", "Office"].map((mode) => (
                          <label key={mode} className="checkbox-label">
                            <input
                              type="checkbox"
                              name="workMode"
                              value={mode}
                              onChange={(e) => handleCheckboxChange(e, "workMode")}
                              checked={formData.workMode.includes(mode)}
                            />
                            <span>{mode}</span>
                          </label>
                        ))}
                      </div>
                    </div>
                    <div className="form-group">
                      <label>Work Category</label>
                      <div className="checkbox-group">
                        {["Internship", "FullTime", "PartTime"].map((category) => (
                          <label key={category} className="checkbox-label">
                            <input
                              type="checkbox"
                              name="workCategory"
                              value={category}
                              onChange={(e) => handleCheckboxChange(e, "workCategory")}
                              checked={formData.workCategory.includes(category)}
                            />
                            <span>{category}</span>
                          </label>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Social Links */}
                  <div className="form-group-title">Social Links</div>

                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="githubURL">GitHub URL</label>
                      <input
                        type="text"
                        name="githubURL"
                        placeholder="https://github.com/username"
                        value={formData.githubURL}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="linkedinURL">LinkedIn URL</label>
                      <input
                        type="text"
                        name="linkedinURL"
                        placeholder="https://linkedin.com/in/username"
                        value={formData.linkedinURL}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  {/* Photo Upload */}
                  <div className="form-group full-width">
                    <label htmlFor="photo">Profile Photo</label>
                    <input
                      type="file"
                      name="photo"
                      id="photo"
                      accept="image/*"
                      onChange={handlePhotoChange}
                      className="file-input"
                    />
                  </div>
                </div>
              </div>

              {/* Form Actions */}
              <div className="form-actions">
                <button
                  type="button"
                  className="btn-cancel"
                  onClick={() => navigate("/CandidateSchedule")}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn-submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default CandidateProfileReg;
